import * as React from "react";
import type { SVGProps } from "react";
const SvgPercent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M18.036 18.061 5.964 5.988M9.6 16.14a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Zm8.4-8.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z"
    />
  </svg>
);
export default SvgPercent01;
